module.exports = "/static/assets/c69b1154248fcd2d2cdb8cde0421ef5a.png";